import { SITE_URL } from "./social";
import brandLogoAsset from "../assets/lifewestway-logo.png.asset.json";

/** Public profiles for the LifeWestWay brand (schema.org `sameAs`). */
export const SOCIAL_PROFILES = [
  "https://x.com/LifeWestWay",
  "https://twitter.com/LifeWestWay",
];

/** Recommended `contactPoint` entries for Organization rich results. */
export const CONTACT_POINTS = [
  {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: "info.lifewestway@gmail.com",
    url: `${SITE_URL}/contact`,
    availableLanguage: ["English"],
    areaServed: ["US", "GB", "AU", "IT", "PT", "CA"],
  },
  {
    "@type": "ContactPoint",
    contactType: "editorial",
    email: "lifewestway@gmail.com",
    url: `${SITE_URL}/contact`,
    availableLanguage: ["English"],
    areaServed: ["US", "GB", "AU", "IT", "PT", "CA"],
  },
  {
    "@type": "ContactPoint",
    contactType: "sales",
    email: "lifewestway@gmail.com",
    url: `${SITE_URL}/contact`,
    availableLanguage: ["English"],
    areaServed: ["US", "GB", "AU", "IT", "PT", "CA"],
  },
];

export const ORGANIZATION_LOGO = `${SITE_URL}${brandLogoAsset.url}`;

/**
 * Canonical Organization node, including the recommended `contactPoint`
 * and `sameAs` properties required for Organization rich results.
 */
export function organizationSchema(overrides: Record<string, unknown> = {}) {
  return {
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "LifeWestWay",
    alternateName: "LifeWestWay Editorial",
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: ORGANIZATION_LOGO,
      caption: "LifeWestWay logo",
    },
    image: ORGANIZATION_LOGO,
    email: "info.lifewestway@gmail.com",
    description:
      "Global expat hub for immigration, jobs, tax, housing and personal finance across the USA, UK, Australia, Italy, Portugal and Canada.",
    contactPoint: CONTACT_POINTS,
    sameAs: SOCIAL_PROFILES,
    ...overrides,
  };
}

/** Canonical WebSite node with search action and publisher reference. */
export function websiteSchema() {
  return {
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: "LifeWestWay",
    url: SITE_URL,
    inLanguage: "en",
    publisher: { "@id": `${SITE_URL}/#organization` },
    sameAs: SOCIAL_PROFILES,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}
